<template>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <tabs type="boxed">
            <tab-pane label="SUPERADMIN">
              <div class="table-responsive">
                <table class="table is-bordered is-striped is-narrow">
                  <thead>
                  <tr>
                    <th></th>
                    <th>Create</th>
                    <th>Read</th>
                    <th>Update</th>
                    <th>Delete</th>
                    <th>Campaign:Moderate / User:SelectUser</th>
                    <th>Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState</th>
                    <th>Campaign:AccessAdditionalParameters / User:UpdateUserPayment</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="permission in permissionMapByRole.SuperAdministrator">
                    <td>{{permission[0]}}</td>
                    <td><input type="checkbox" value="permission[1]" v-model="permission[1]"></td>
                    <td><input type="checkbox" value="permission[2]" v-model="permission[2]"></td>
                    <td><input type="checkbox" value="permission[3]" v-model="permission[3]"></td>
                    <td><input type="checkbox" value="permission[4]" v-model="permission[4]"></td>
                    <td><input type="checkbox" value="permission[5]" v-model="permission[5]"></td>
                    <td><input type="checkbox" value="permission[6]" v-model="permission[6]"></td>
                    <td><input type="checkbox" value="permission[7]" v-model="permission[7]"></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </tab-pane>
            <tab-pane label="ADMIN">
              <div class="table-responsive">
                <table class="table is-bordered is-striped is-narrow">
                  <thead>
                  <tr>
                    <th></th>
                    <th>Create</th>
                    <th>Read</th>
                    <th>Update</th>
                    <th>Delete</th>
                    <th>Campaign:Moderate / User:SelectUser</th>
                    <th>Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState</th>
                    <th>Campaign:AccessAdditionalParameters / User:UpdateUserPayment</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="permission in permissionMapByRole.Administrator">
                    <td>{{permission[0]}}</td>
                    <td><input type="checkbox" value="permission[1]" v-model="permission[1]"></td>
                    <td><input type="checkbox" value="permission[2]" v-model="permission[2]"></td>
                    <td><input type="checkbox" value="permission[3]" v-model="permission[3]"></td>
                    <td><input type="checkbox" value="permission[4]" v-model="permission[4]"></td>
                    <td><input type="checkbox" value="permission[5]" v-model="permission[5]"></td>
                    <td><input type="checkbox" value="permission[6]" v-model="permission[6]"></td>
                    <td><input type="checkbox" value="permission[7]" v-model="permission[7]"></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </tab-pane>
            <tab-pane label="PARTNER">
              <div class="table-responsive">
                <table class="table is-bordered is-striped is-narrow">
                  <thead>
                  <tr>
                    <th></th>
                    <th>Create</th>
                    <th>Read</th>
                    <th>Update</th>
                    <th>Delete</th>
                    <th>Campaign:Moderate / User:SelectUser</th>
                    <th>Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState</th>
                    <th>Campaign:AccessAdditionalParameters / User:UpdateUserPayment</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="permission in permissionMapByRole.Partner">
                    <td>{{permission[0]}}</td>
                    <td><input type="checkbox" value="permission[1]" v-model="permission[1]"></td>
                    <td><input type="checkbox" value="permission[2]" v-model="permission[2]"></td>
                    <td><input type="checkbox" value="permission[3]" v-model="permission[3]"></td>
                    <td><input type="checkbox" value="permission[4]" v-model="permission[4]"></td>
                    <td><input type="checkbox" value="permission[5]" v-model="permission[5]"></td>
                    <td><input type="checkbox" value="permission[6]" v-model="permission[6]"></td>
                    <td><input type="checkbox" value="permission[7]" v-model="permission[7]"></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </tab-pane>
            <tab-pane label="REFERRER">
              <div class="table-responsive">
                <table class="table is-bordered is-striped is-narrow">
                  <thead>
                  <tr>
                    <th></th>
                    <th>Create</th>
                    <th>Read</th>
                    <th>Update</th>
                    <th>Delete</th>
                    <th>Campaign:Moderate / User:SelectUser</th>
                    <th>Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState</th>
                    <th>Campaign&Client:AccessAdditionalParameters / User:UpdateUserPayment</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="permission in permissionMapByRole.Referrer">
                    <td>{{permission[0]}}</td>
                    <td><input type="checkbox" value="permission[1]" v-model="permission[1]"></td>
                    <td><input type="checkbox" value="permission[2]" v-model="permission[2]"></td>
                    <td><input type="checkbox" value="permission[3]" v-model="permission[3]"></td>
                    <td><input type="checkbox" value="permission[4]" v-model="permission[4]"></td>
                    <td><input type="checkbox" value="permission[5]" v-model="permission[5]"></td>
                    <td><input type="checkbox" value="permission[6]" v-model="permission[6]"></td>
                    <td><input type="checkbox" value="permission[7]" v-model="permission[7]"></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </tab-pane>
            <tab-pane label="CLIENT">
              <div class="table-responsive">
                <table class="table is-bordered is-striped is-narrow">
                  <thead>
                  <tr>
                    <th></th>
                    <th>Create</th>
                    <th>Read</th>
                    <th>Update</th>
                    <th>Delete</th>
                    <th>Campaign:Moderate / User:SelectUser</th>
                    <th>Campaign:UpdateAfterModerating / User:UpdateUserTypeAndState</th>
                    <th>Campaign:AccessAdditionalParameters / User:UpdateUserPayment</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="permission in permissionMapByRole.Client">
                    <td>{{permission[0]}}</td>
                    <td><input type="checkbox" value="permission[1]" v-model="permission[1]"></td>
                    <td><input type="checkbox" value="permission[2]" v-model="permission[2]"></td>
                    <td><input type="checkbox" value="permission[3]" v-model="permission[3]"></td>
                    <td><input type="checkbox" value="permission[4]" v-model="permission[4]"></td>
                    <td><input type="checkbox" value="permission[5]" v-model="permission[5]"></td>
                    <td><input type="checkbox" value="permission[6]" v-model="permission[6]"></td>
                    <td><input type="checkbox" value="permission[7]" v-model="permission[7]"></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </tab-pane>
          </tabs>
          <button v-if="canUpdate(permissionKey)" class="button is-primary" v-on:click="save">
              <span class="icon">
                <i class="fa fa-floppy-o"></i>
              </span>
            <span>Сохранить</span>
          </button>
          <button class="button is-light" v-on:click="cancel">
              <span class="icon">
                <i class="fa fa-times-circle"></i>
              </span>
            <span>Закрыть</span>
          </button>
          <button v-if="canUpdate(permissionKey)" class="button is-warning" v-on:click="setDefaultPermissions">
              <span class="icon">
                <i class="fa fa-industry"></i>
              </span>
            <span>Установить значения по умолчанию</span>
          </button>
        </article>
      </div>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'
import Vue from 'vue'
import Notification from 'vue-bulma-notification'
import Cleave from 'vue-cleave'
import { Tabs, TabPane } from 'vue-bulma-tabs'
import CheckToken from '../authentication/CheckToken'
import CheckPermission from '../authentication/CheckPermission'

Vue.mixin(CheckToken)
Vue.mixin(CheckPermission)

const NotificationComponent = Vue.extend(Notification)
const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}


const AUTH_API = '/api/auth'

export default {
  props: ['id'],
  components: {
    Cleave,
    Notification,
    Tabs,
    TabPane
  },
  data () {
    return {
      permissionKey: 'permission',
      permissionMapByRole: {
        SuperAdministrator: [],
        Administrator: [],
        Partner: [],
        Referrer: [],
        Client: []
      }
    }
  },
  created: function () {
    this.checkToken()
    this.handlePermissions()
  },
  computed: {
    ...mapGetters([
      'authenticationToken',
      'loggedUser',
      'loggedId'
    ])
  },
  methods: {
    prepareSecurityHeader() {
      console.log(this.authenticationToken)
      return {
        Authorization: `Bearer ${this.authenticationToken}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      }
    },
    save () {
      this.$http.post(AUTH_API + '/setPermissions', this.permissionMapByRole, {headers: this.prepareSecurityHeader()})
              .then((response) => {
              }).catch((error) => {
              console.log(error)
              this.openNotificationWithType('danger', 'Ошибка сохранения пользовательских разрешений')
            })
    },
    handlePermissions () {
      console.log('loading permissions')
      this.loadPermissions('SuperAdministrator')
      this.loadPermissions('Administrator')
      this.loadPermissions('Partner')
      this.loadPermissions('Referrer')
      this.loadPermissions('Client')
    },
    loadPermissions (role) {
      this.$http.get(AUTH_API + '/getPermissions/' + role, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.permissionMapByRole[role] = []
          var arrPermissions = (JSON.parse(JSON.stringify(Object.entries(response.data))))
          for (var i = 0, len = arrPermissions.length; i < len; i++) {
            const permission = []
            permission.push(arrPermissions[i][0])
            permission.push((arrPermissions[i][1] & 1) === 1)
            permission.push((arrPermissions[i][1] & 2) === 2)
            permission.push((arrPermissions[i][1] & 4) === 4)
            permission.push((arrPermissions[i][1] & 8) === 8)
            permission.push((arrPermissions[i][1] & 16) === 16)
            permission.push((arrPermissions[i][1] & 32) === 32)
            permission.push((arrPermissions[i][1] & 64) === 64)
            this.permissionMapByRole[role].push(permission)
          }
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка загрузки пользовательских разрешений. ')
        })
    },
    setDefaultPermissions() {
      this.$http.post(AUTH_API + '/setDefaultPermissions', {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.handlePermissions()
          this.openNotificationWithType('warning', 'Установлены значения по умолчанию')
        })
        .catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка загрузки разрешений "По умолчанию". ')
        })
    },
    cancel () {
      this.$router.push('/campaigns')
    },
    openNotificationWithType (type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      })
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../../../node_modules/bulma/sass/utilities/mixins';

.time {
  margin: 0px 10px;
}

</style>



// WEBPACK FOOTER //
// Permissions.vue?e02a8a8c